export enum MODES {
    NOT_FOUND = 'not-found',
    SUGGEST = 'suggest',
}

export const DEBOUNCE_MS = 300;
export const SUGGEST_OPTIONS_LIMIT = 10;
